// import "./style.css"
import React, { Component, useEffect, useState } from 'react';
// import GoldParticles from './GoldParticles'; 
import first from '../../Assets/Images/first.png'
import second from '../../Assets/Images/second.png'
import third from '../../Assets/Images/third.png'

const OffPlan = () => {
    const[topThree, setTopThree] = useState('')
    const [lastMonthInfo, setLastMonthInfo] = useState({ start: '', end: '', name: '' });

    useEffect(() => {
        const { start, end, name } = getLastMonthRange();
        setLastMonthInfo({ start, end, name });

        async function fetchTop() {
            const response = await fetch(`https://deals.axcrm.ae/backend/api/get-top-agents?key=${process.env.REACT_APP_AXDEALS_API_KEY}&start_date=${start}&end_date=${end}&is_split=1&items_per_page=10`);
            const json = await response.json();
            setTopThree(json.top_3);
        }

        fetchTop();
    }, []);



    function getLastMonthRange() {
        const now = new Date();
        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
        const lastMonthStart = new Date(lastMonthEnd.getFullYear(), lastMonthEnd.getMonth(), 1);

        const format = (date) => date.toLocaleDateString('en-CA'); // YYYY-MM-DD в локальной зоне

        return {
            start: format(lastMonthStart),
            end: format(lastMonthEnd),
            name: lastMonthEnd.toLocaleString('default', { month: 'long', year: 'numeric' }),
        };
    }
    if(!topThree){
        return<>....</>
    }

    // const sorting = offplan.sort((a, b) => b.amount - a.amount);
    // const three = sorting.slice(0, 3)
    // const seven = sorting.slice(3)
    // console.log(three)
    // console.log(seven)

    return <>
        {/* <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="mvp-position">
                        <div className="mvp-screen">
                            <h1 className="main-title">Top 3  Sales Performers Of May 2025 Primary</h1>
                            <div className="img-mvp-block three-img-mvp-block">
                                <div className="item">
                                    <div className="card-mvp">
                                        <div className="img-mvp">
                                            <img src="https://upload-5b6ed3f1470f864e3426fe4c1fe063ed.s3.amazonaws.com/main/2b7/2b7e3254cdb7d4288af7f61c90abfd8c/Vitalii-Gunevoi.jpg.png" alt="" />
                                        </div>
                                        <div className="mvp-body">
                                            <h3>Vitalii Gunevoi</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="card-mvp">
                                        <div className="img-mvp">
                                            <img src="https://upload-5b6ed3f1470f864e3426fe4c1fe063ed.s3.amazonaws.com/main/81a/81a24eb16d5ba41a0d3d788c2f5c912d/photo_2024-05-25_12-45-06.jpg" alt="" />
                                        </div>
                                        <div className="mvp-body">
                                            <h3>Vadim Negru</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="card-mvp">
                                        <div className="img-mvp">
                                            <img src="https://upload-5b6ed3f1470f864e3426fe4c1fe063ed.s3.amazonaws.com/main/5f0/5f026c9ae62bf615812383fdbf2fff93/Andrian-Trestianu-_1_.jpg.png" alt="" />
                                        </div>
                                        <div className="mvp-body">
                                            <h3>Andrian Trestianu</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}


        <div className="container-fluid top3">
            <h3>🏆 Top 3 Sales Performers Of {lastMonthInfo.name} Primary</h3>
            <div className="row three-col">
                <div className="col-md-4" style={{ marginTop: '50px' }}>
                    <div className="card">
                        <div className="img-section">
                            <img src={topThree[1].image_path} alt="" />
                        </div>
                        <div className="d-flex winner">
                            <h4>{topThree[1].name}</h4>
                            <img src={second} alt="" />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="img-section">
                            <img src={topThree[0].image_path} alt="" />
                        </div>
                        <div className="d-flex winner">
                            <h4>{topThree[0].name}</h4>
                            <img src={first} alt="" />
                        </div>
                    </div>
                </div>
                <div className="col-md-4" style={{ marginTop: '100px' }}>
                    <div className="card">
                        <div className="img-section">
                            <img src={topThree[2].image_path} alt="" />
                        </div>
                        <div className="d-flex winner">
                            <h4>{topThree[2].name}</h4>
                            <img src={third} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="row justify-content-center columns four-col mt-4">
                {seven.map((item) => (
                    <div className="col" key={item.id}>
                        <div className="card">
                        <img src={item.AgentImg} alt="" />
                            <div className="d-flex winner">
                                <h4>{item.Name}</h4>
                            </div>
                        </div>
                    </div>
                ))}
            </div> */}
       </div>
    </>
}

export default OffPlan;
